import { render } from "./PolicyChanges.vue?vue&type=template&id=6fe9ead4&scoped=true"
import script from "./PolicyChanges.vue?vue&type=script&lang=js"
export * from "./PolicyChanges.vue?vue&type=script&lang=js"

import "./PolicyChanges.vue?vue&type=style&index=0&id=6fe9ead4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe9ead4"]])

export default __exports__